module.exports = __webpack_public_path__ + "static/media/Arrow-Circle-Disabled.01c07454.svg";